import Vue from 'vue';
import router from '@/router';
import store from '@/store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css'; // progress bar style
// 后端返回的目录
const data = {
	data: [
		{
			path: '/welcome',
			title: '首页',
			icon: 'el-icon-s-home',
			affix: true // 标签是否可以关闭 true-不可关闭
		},
		{
			path: '/index',
			title: '统计页',
			icon: 'el-icon-monitor',
			affix: false // 标签是否可以关闭 true-不可关闭
		},
		// 代理 / 客服数据
		{
			title: '数据模型',
			icon: 'el-icon-aim',
			children: [
				{ path: '/domain/group', title: '域名分组', icon: 'el-icon-collection-tag', affix: false },
				{
					path: '/domian/list',
					title: '域名管理',
					icon: 'el-icon-link',
					affix: false
				},
				{
					path: '/short-link/manage',
					title: '目标地址',
					icon: 'el-icon-setting',
					affix: false
				},
				{
					path: '/ip/list',
					title: 'IP与黑名单',
					icon: 'el-icon-position',
					affix: false
				}
			]
		},
		// 归类一下
		{
			title: '系统管理',
			icon: 'el-icon-setting',
			children: [
				{
					path: '/kf/adminu',
					title: '用户管理',
					icon: 'el-icon-s-custom',
					affix: false
				},
				{
					path: '/config/language',
					title: '语言设置',
					icon: 'el-icon-s-order',
					affix: false
				},
				{
					path: '/config/system',
					title: '系统配置',
					icon: 'el-icon-s-order',
					affix: false
				},
				{
					path: '/country/whitelist',
					title: '国家白名单',
					icon: 'el-icon-location-information',
					affix: false
				}
			]
		}
	],
	code: 200,
	message: '成功'
};

// 获取后端路由表
const setMenulist = async () => {
	try {
		// const { data } = await getMenuList();
		await store.commit('setMenuList', data.data || []);
	} catch (error) {
		await store.commit('setMenuList', []);
	}
};

// 全局路由守卫
// 用于判断权限
router.beforeEach(async (to, from, next) => {
	NProgress.start();
	if (typeof to.meta.permission === 'boolean') {
		if (store.state.layout.menuList.length <= 0) {
			await setMenulist();
		}
		const info = sessionStorage.getItem('admin-info');
		// const token = sessionStorage.getItem('admin-token');
		if (!info && to.path !== '/login') {
			// next();
			// NProgress.done();
			next('/login');
			NProgress.done();
		} else if (to.meta.permission) {
			next();
			NProgress.done();
		} else {
			next('/401'); // 无权限
			NProgress.done();
		}
	} else {
		next(); // 不需要权限验证的页面
		NProgress.done();
	}
});

router.beforeEach((to, from, next) => {
	// 小屏下路由切换时收起侧边栏
	if (store.state.facility.screenWidth < 1200) {
		store.commit('setCollapse', true);
	}

	/**
	 * 处理携带参数的路由
	 * 如果当前页面tab已存在，但是参数不一样的话会删除缓存再进入
	 * 只处理了通过query传参，其他的最好不要使用
	 */
	const found = store.state.layout.tabs.find((item) => item.path === to.path);
	if (found && found.to !== to.fullPath) {
		store.commit('setRedirectName', to.name);
		Vue.nextTick(() => {
			next();
			store.commit('setRedirectName', '');
			NProgress.done();
		});
	} else {
		next();
		NProgress.done();
	}
});

router.afterEach((to) => {
	if (to.path.slice(0, 9) !== '/redirect') {
		NProgress.done();
	}
});
